import React from "react";
import styles from "./styles.module.css";
import logo from "./logo.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
const Loading = () => (

  <LazyLoadImage
    src={logo}
    alt="loading"
    className={styles.loading}
    height={200}
    width={200}
  />

  // <img src={logo} alt="loading" className={styles.loading} loading="lazy" />
);
export default Loading;
